import { Component, Input, OnInit, inject } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AsyncPipe } from '@angular/common';
import {
  BehaviorSubject,
  Observable,
  combineLatest,
  distinctUntilChanged,
  map,
} from 'rxjs';
import { LoadingService } from '@ao/shared/services/loading.service';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
  imports: [ProgressSpinnerModule, AsyncPipe],
})
export class SpinnerComponent implements OnInit {
  private loadingService = inject(LoadingService);
  private router = inject(Router);
  private routeLoadCount$ = new BehaviorSubject<number>(0);

  loading$!: Observable<boolean>;

  @Input()
  detectRouteTransitions = false;

  ngOnInit() {
    this.loading$ = combineLatest([
      this.loadingService.loading$,
      this.routeLoadCount$.pipe(map(count => count > 0)),
    ]).pipe(
      map(([http, route]) => http || route),
      distinctUntilChanged()
    );

    if (this.detectRouteTransitions) {
      this.router.events.subscribe(event => {
        if (event instanceof RouteConfigLoadStart) {
          this.routeLoadCount$.next(this.routeLoadCount$.value + 1);
        } else if (event instanceof RouteConfigLoadEnd) {
          this.routeLoadCount$.next(
            Math.max(0, this.routeLoadCount$.value - 1)
          );
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          if (this.routeLoadCount$.value !== 0) {
            this.routeLoadCount$.next(0);
          }
        }
      });
    }
  }
}
